import React from "react";
import { StoryChapter } from "../StoryChapter";
import { agencyImages, ecommerceImages } from "../../data/story";
export function Journey() {
  return <section className="mx-auto max-w-7xl px-5 py-16 sm:px-6 md:py-28" data-id="element-99" data-mp="3ieppc7vklsvq">
      <div className="max-w-3xl" data-id="element-100" data-mp="34kf6262ceqx2">
        <h2 className="font-display text-4xl font-black uppercase leading-none md:text-6xl" data-id="element-101" data-mp="34jdvs3t5i8ge">No fue un camino en línea recta.</h2>
        <p className="mt-6 text-xl leading-relaxed text-paper/70" data-id="element-102" data-mp="2umhlbsjozc97">
          Después de los globos llegaron nuevos intentos. Nuevos negocios. Nuevos errores. Nuevos aprendizajes.
        </p>
      </div>

      <div className="mt-12 space-y-16 md:mt-20 md:space-y-32" data-id="element-103" data-mp="2lmun1fm9emkd">
        <StoryChapter stage="E-commerce" title="Aprendí a vender productos físicos." images={ecommerceImages} data-id="element-104" data-mp="2lop76rppiane">
          <p data-id="element-105" data-mp="juzkbphzdsea">A entender clientes.</p>
          <p data-id="element-106" data-mp="jw10279xz32c">A crear ofertas.</p>
          <p data-id="element-107" data-mp="jsv9enlnzt4i">A enfrentar problemas reales de un negocio.</p>
        </StoryChapter>

        <StoryChapter stage="Agencia de marketing" title="Después construí una agencia." images={agencyImages} reverse data-id="element-108" data-mp="nw1e3qt4pc8v">
          <p data-id="element-109" data-mp="2wijvebv4rfax">Aprendí a conseguir clientes. A vender servicios. A trabajar con equipos. A generar resultados para otras empresas.</p>
          <p data-id="element-110" data-mp="36a6d8r1z4cmn">Pero también descubrí algo:</p>
          <p className="text-paper" data-id="element-111" data-mp="369wpzb8bcjkn">No quería construir solamente el negocio de alguien más.</p>
          <p className="text-paper" data-id="element-112" data-mp="31bv6ip6z6i8n">Quería construir algo que pudiera crecer sin depender completamente de mi tiempo.</p>
        </StoryChapter>

        <StoryChapter stage="Productos digitales" title="Y entonces llegaron los productos digitales." data-id="element-113" data-mp="28mpcixidnm6a">
          <p data-id="element-114" data-mp="2njoqr47qid9q">Empecé a entender algo que cambió completamente mi manera de hacer negocios:</p>
          <p className="border-l-2 border-accent pl-4 text-xl font-medium text-paper" data-id="element-115" data-mp="2ikvbp7csue7g">
            Puedes crear una solución una vez y construir un sistema alrededor de ella para venderla una y otra vez.
          </p>
          <p data-id="element-116" data-mp="3u0k0835pblad">Probé. Fallé. Volví a probar.</p>
          <p data-id="element-117" data-mp="3tzr0vn92ny29">
            Encontré productos que funcionaban. Aprendí a identificar oportunidades. Aprendí a crear ofertas. Aprendí a vender. Aprendí a escalar.
          </p>
          <p className="text-paper" data-id="element-118" data-mp="9vw2h8hxkvr7">Y poco a poco… el sistema comenzó a funcionar.</p>
        </StoryChapter>
      </div>
    </section>;
}